export const replaceBelarusianRuble = (string: string | undefined): string =>
	string ? string.replace(/(?:р|руб)\./gi, '\uF100') : '';
